import React from "react";
import {Menu, X} from "lucide-react";
import {useState} from "react";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <div className="flex items-center">
                        <img
                            src={require('../../assets/m4m-logo.png')}
                            alt="Manage4Me Logo"
                            className="h-10 w-10 mr-3"
                        />
                        <span className="text-xl font-bold" style={{color: '#0c1248'}}>

                        <a className="font-bold" style={{color: '#0c1248'}}
                           href="https://apps.manage4me.org/">Manage4Me</a>
            </span>
                    </div>
                </div>
            </div>


        </header>
    );
};

export default Header;